// Backend amounts are in the smallest currency unit (cents)
export const CENTS_PER_UNIT = 100
